import Vue from 'vue'
import Router from 'vue-router'
import pcindex from '@/components/pc/index'
import index from '@/components/wap/index'
import login from '@/components/wap/public/login'
import register from '@/components/wap/public/register'
import activity from '@/components/wap/activity'

Vue.use(Router)
const isMobile = function() {
	let flag = navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	);
	return flag;
};

// console.log(isMobile(), "isMobile")
export default new Router({
	mode: 'hash', //'history',
	// base: process.env.BASE_URL,
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [{
			path: '/',
			redirect: isMobile() ? '/welcome' : '/pcindex', //根路径的重定向
		},
		// PC端
		{
			path: '/pcindex',
			name: 'pcindex',
			component: pcindex
		},
		{
			path: '/pcsports',
			name: 'pcsports',
			component: () => import('@/components/pc/sports')
		},
		{
			path: '/pconsite',
			name: 'pconsite',
			component: () => import('@/components/pc/onsite')
		},
		{
			path: '/pcChess',
			name: 'pcChess',
			component: () => import('@/components/pc/Chesscards')
		},
		{
			path: '/pcegames',
			name: 'pcegames',
			component: () => import('@/components/pc/egames')
		},
		{
			path: '/pclottery',
			name: 'pclottery',
			component: () => import('@/components/pc/lottery')
		},
		{
			path: '/pcfishing',
			name: 'pcfishing',
			component: () => import('@/components/pc/fishing')
		},
		{
			path: '/pcactivity',
			name: 'pcactivity',
			component: () => import('@/components/pc/activity')
		},
		{
			path: '/pcacvdetails',
			name: 'pcacvdetails',
			component: () => import('@/components/pc/acvdetails.vue'),
			// props: route => ({id: route.query.id})
		},
		{
			path: '/pckefu',
			name: 'pckefu',
			component: () => import('@/components/pc/kefu.vue')
		},
		{
			path: '/pcweb',
			name: 'pcweb',
			component: () => import('@/components/pc/web.vue')
		},
		{
			path: '/pchtmlCont',
			name: 'pchtmlCont',
			component: () => import('@/components/pc/htmlCont.vue')
		},
		{
			path: '/linkpage',
			name: 'linkpage',
			component: () => import('@/components/pc/linkpage.vue')
		},
		{
			path: '/pcHelloWorld',
			name: 'pcHelloWorld',
			component: () => import('@/components/pc/HelloWorld.vue')
		},
		{
			path: '/pcmemberCenter',
			name: 'pcmemberCenter',
			component: () => import('@/components/pc/member/center.vue')
		},
		{
			path: '/pcrecords',
			name: 'pcrecords',
			component: () => import('@/components/pc/member/records.vue')
		},
		{
			path: '/pcfanshui',
			name: 'pcfanshui',
			component: () => import('@/components/pc/member/fanshui.vue')
		},
		{
			path: '/pcrecharge',
			name: 'pcrecharge',
			component: () => import('@/components/pc/member/recharge.vue')
		},
		{
			path: '/pctransfer',
			name: 'pctransfer',
			component: () => import('@/components/pc/member/transfer.vue')
		},
		{
			path: '/pctransrecord',
			name: 'pctransrecord',
			component: () => import('@/components/pc/member/transrecord.vue')
		},
		{
			path: '/pchytransfer',
			name: 'pchytransfer',
			component: () => import('@/components/pc/member/hytransfer.vue')
		},
		{
			path: '/pcvip',
			name: 'pcvip',
			component: () => import('@/components/pc/member/vip.vue')
		},
		{
			path: '/pcwithdraw',
			name: 'pcwithdraw',
			component: () => import('@/components/pc/member/withdraw.vue')
		},
		{
			path: '/pclogin',
			name: 'pclogin',
			component: () => import('@/components/pc/member/login.vue')
		},
		{
			path: '/pcregister',
			name: 'pcregister',
			component: () => import('@/components/pc/member/register.vue')
		},
		{
			path: '/pcforgetpass',
			name: 'pcforgetpass',
			component: () => import('@/components/pc/member/forgetpass.vue')
		},
		{
			path: '/pcpay',
			name: 'pcpay',
			component: () => import('@/components/pc/member/pay.vue')
		},
		{
			path: '/pcmessage',
			name: 'pcmessage',
			component: () => import('@/components/pc/member/message.vue')
		},
		{
			path: '/pcgameRecord',
			name: 'pcgameRecord',
			component: () => import('@/components/pc/member/gamerecord.vue')
		},
		{
			path: '/pcRedeemCode',
			name: 'pcRedeemCode',
			component: () => import('@/components/pc/member/RedeemCode.vue')
		},

		{
			path: '/pctgindex',
			name: 'pctgindex',
			component: () => import('@/components/pc/push/tgindex.vue')
		},
		{
			path: '/pcctrecords',
			name: 'pcctrecords',
			component: () => import('@/components/pc/push/ctrecords.vue')
		},
		{
			path: '/pcviptake',
			name: 'pcviptake',
			component: () => import('@/components/pc/push/viptake.vue')
		},
		{
			path: '/pcgamejl',
			name: 'pcgamejl',
			component: () => import('@/components/pc/push/gamejl.vue')
		}, {
			path: '/pcgamebet',
			name: 'pcgamebet',
			component: () => import('@/components/pc/push/gamebet.vue')
		},
		{
			path: '/pcyjjs',
			name: 'pcyjjs',
			component: () => import('@/components/pc/push/yjjs.vue')
		},
		{
			path: '/pcplateRecord',
			name: 'pcplateRecord',
			component: () => import('@/components/pc/push/plateRecord.vue')
		},
		{
			path: '/pccontact',
			name: 'pccontact',
			component: () => import('@/components/pc/help/contact.vue')
		},
		{
			path: '/pcDisclaimers',
			name: 'pcDisclaimers',
			component: () => import('@/components/pc/help/Disclaimers.vue')
		},
		{
			path: '/pcPolicy',
			name: 'pcPolicy',
			component: () => import('@/components/pc/help/Policy.vue')
		},
		{
			path: '/pcproblem',
			name: 'pcproblem',
			component: () => import('@/components/pc/help/problem.vue')
		},
		{
			path: '/pcresponsibility',
			name: 'pcresponsibility',
			component: () => import('@/components/pc/help/responsibility.vue')
		},
		{
			path: '/pcabout',
			name: 'pcabout',
			component: () => import('@/components/pc/help/about.vue')
		},
		{
			path: '/pcjoinus',
			name: 'pcjoinus',
			component: () => import('@/components/pc/help/joinus.vue')
		},
		{
			path: '/pcconceal',
			name: 'pcconceal',
			component: () => import('@/components/pc/help/conceal.vue')
		},
		{
			path: '/pcusdt',
			name: 'pcusdt',
			component: () => import('@/components/pc/help/usdt.vue')
		},
		
		// 手机端页面
		{
			path: '/welcome',
			name: 'welcome',
			component: () => import('@/components/wap/welcome')
		},
		{
			path: '/index',
			name: 'index',
			component: index
		},
		{
			path: '/login',
			name: 'login',
			component: login
		},
		{
			path: '/register',
			name: 'register',
			component: register
		},
		{
			path: '/activity',
			name: 'activity',
			component: activity
		},
		{
			path: '/actDetail',
			name: 'actDetail',
			component: () => import('@/components/wap/actDetail')
		},
		{
			path: '/money',
			name: 'money',
			component: () => import('@/components/wap/money')
		},
		{
			path: '/recharge',
			name: 'recharge',
			component: () => import('@/components/wap/recharge')
		},
		{
			path: '/transfer',
			name: 'transfer',
			component: () => import('@/components/wap/transfer')
		},
		{
			path: '/withdraw',
			name: 'withdraw',
			component: () => import('@/components/wap/withdraw')
		},
		{
			path: '/bankCard',
			name: 'bankCard',
			component: () => import('@/components/wap/bankCard')
		},
		{
			path: '/my',
			name: 'my',
			component: () => import('@/components/wap/my')
		},
		{
			path: '/center',
			name: 'center',
			component: () => import('@/components/wap/center')
		},
		{
			path: '/vip',
			name: 'vip',
			component: () => import('@/components/wap/vip')
		},
		{
			path: '/transRecord',
			name: 'transRecord',
			component: () => import('@/components/wap/transRecord')
		},
		{
			path: '/betRecord',
			name: 'betRecord',
			component: () => import('@/components/wap/betRecord')
		},
		{
			path: '/setting',
			name: 'setting',
			component: () => import('@/components/wap/setting')
		},
		{
			path: '/message',
			name: 'message',
			component: () => import('@/components/wap/message')
		},
		{
			path: '/backWater',
			name: 'backWater',
			component: () => import('@/components/wap/backWater')
		},
		{
			path: '/help',
			name: 'help',
			component: () => import('@/components/wap/help')
		},
		{
			path: '/activityRecord',
			name: 'activityRecord',
			component: () => import('@/components/wap/activityRecord')
		},
		{
			path: '/welfare',
			name: 'welfare',
			component: () => import('@/components/wap/welfare')
		},
		{
			path: '/app',
			name: 'app',
			component: () => import('@/components/wap/app')
		},
		{
			path: '/helpInfo',
			name: 'helpInfo',
			component: () => import('@/components/wap/helpInfo')
		},
		{
			path: '/games',
			name: 'games',
			component: () => import('@/components/wap/games')
		},
		{
			path: '/gameList',
			name: 'gameList',
			component: () => import('@/components/wap/gameList')
		},
		{
			path: '/kefu',
			name: 'kefu',
			component: () => import('@/components/wap/kefu')
		},
		{
			path: '/link',
			name: 'link',
			component: () => import('@/components/wap/link')
		},
		{
			path: '/records',
			name: 'records',
			component: () => import('@/components/wap/records')
		},
		{
			path: '/pay',
			name: 'pay',
			component: () => import('@/components/wap/pay')
		},
		{
			path: '/web',
			name: 'web',
			component: () => import('@/components/wap/web')
		},
		{
			path: '/find',
			name: 'find',
			component: () => import('@/components/wap/find')
		},
		{
			path: '/collect',
			name: 'collect',
			component: () => import('@/components/wap/collect')
		},
		{
			path: '/search',
			name: 'search',
			component: () => import('@/components/wap/search')
		},
		{
			path: '/SportLive',
			name: 'SportLive',
			component: () => import('@/components/wap/SportLive')
		},
		{
			path: '/play',
			name: 'play',
			component: () => import('@/components/wap/play')
		}, {
			path: '/moreList',
			name: 'moreList',
			component: () => import('@/components/wap/moreList')
		},
		{
			path: '/gameRecord',
			name: 'gameRecord',
			component: () => import('@/components/wap/gameRecord')
		},
		{
			path: '/betDetail',
			name: 'betDetail',
			component: () => import('@/components/wap/betDetail')
		},
		{
			path: '/withdrawIndex',
			name: 'withdrawIndex',
			component: () => import('@/components/wap/withdrawIndex')
		},

		{
			path: '/tgindex',
			name: 'tgindex',
			component: () => import('@/components/wap/push/tgindex')
		},
		{
			path: '/plateRecord',
			name: 'plateRecord',
			component: () => import('@/components/wap/push/plateRecord')
		},
		{
			path: '/findvip',
			name: 'findvip',
			component: () => import('@/components/wap/push/findvip')
		},
		{
			path: '/gamejl',
			name: 'gamejl',
			component: () => import('@/components/wap/push/gamejl')
		},
		{
			path: '/gamebet',
			name: 'gamebet',
			component: () => import('@/components/wap/push/gamebet')
		},
		{
			path: '/source',
			name: 'source',
			component: () => import('@/components/wap/push/source')
		},
		{
			path: '/yjjs',
			name: 'yjjs',
			component: () => import('@/components/wap/push/yjjs')
		},
		{
			path: '/viptake',
			name: 'viptake',
			component: () => import('@/components/wap/push/viptake')
		},
		{
			path: '/ctrecords',
			name: 'ctrecords',
			component: () => import('@/components/wap/push/ctrecords')
		},
		{
			path: '/noble',
			name: 'noble',
			component: () => import('@/components/wap/noble')
		},
		{
			path: '/auth',
			name: 'auth',
			component: () => import('@/components/wap/auth')
		},
		{
			path: '/applock',
			name: 'applock',
			component: () => import('@/components/wap/applock')
		}, {
			path: '/recordsType',
			name: 'recordsType',
			component: () => import('@/components/wap/recordsType')
		}, {
			path: '/gameTransfer',
			name: 'gameTransfer',
			component: () => import('@/components/wap/gameTransfer')
		}, {
			path: '/appindex',
			name: 'appindex',
			component: () => import('@/components/wap/appindex')
		}, {
			path: '/htmlCont',
			name: 'htmlCont',
			component: () => import('@/components/wap/htmlCont')
		}, {
			path: '/findpaypass',
			name: 'findpaypass',
			component: () => import('@/components/wap/findpaypass')
		}, {
			path: '/RedeemCode',
			name: 'RedeemCode',
			component: () => import('@/components/wap/RedeemCode')
		}, {
			path: '/dhrecords',
			name: 'dhrecords',
			component: () => import('@/components/wap/dhrecords')
		}
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js